import React from "react";
import {withRouter} from "../../Utility/withRouter";
import {NotFound} from "../Error/NotFound";
import MobilesBohrWerk from "./MobilesBohrWerk/MobilesBohrWerk";

class Maschinen extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            machine: document.location.pathname.split(`/machines/`)[1].split(`/`)[0],
            machines: [
                {
                    name: `mobiles-bohrwerk`,
                    component: <MobilesBohrWerk/>
                }
            ]
        };

    }
    render() {
        console.log(this.state.machines.find((maschine: any) => maschine.name === this.state.machine)?.component);

        return (
            this.state.machines.find((maschine: any) => maschine.name === this.state.machine)?.component ||  <NotFound />
        );
    }
}

export default withRouter(Maschinen);